import React from "react";
function Loader(props) {
  return <div id={"load-icon"}></div>;
}

export default Loader;
